<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" label-width="90px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="租户类型" prop="tenantType">
            <el-select
              v-model="queryParams.tenantType"
              placeholder="请选择类型"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="dict in typeOptions"
                :key="dict.code"
                :label="dict.name"
                :value="dict.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="租户名称" prop="tenantName">
            <el-input v-model="queryParams.tenantName" placeholder="请输入租户名称" clearable />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="负责人" prop="linkNickName">
            <el-input v-model="queryParams.linkNickName" placeholder="请输入负责人" clearable />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="手机号" prop="linkTel">
            <el-input v-model="queryParams.linkTel" placeholder="请输入手机号" clearable />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="首页推荐" prop="homePageRecommend">
            <el-select
              v-model="queryParams.homePageRecommend"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="dict in statusList"
                :key="dict.value"
                :label="dict.name"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="频道屏蔽" prop="companyHallShow">
            <el-select
              v-model="queryParams.companyHallShow"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="dict in showList"
                :key="dict.value"
                :label="dict.name"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-table v-loading="loading" :data="dataList" @cell-dblclick="dbClick">
      <el-table-column label="租户名称" min-width="150" align="center" prop="tenantName" />
      <el-table-column label="租户类型" min-width="80" align="center" prop="tenantTypeDesc" />
      <el-table-column label="绑定手机号" min-width="60" align="center" prop="linkTel"/>
      <el-table-column label="负责人" min-width="60" align="center" prop="linkNickName" />
      <el-table-column label="首页推荐" min-width="90" align="center" prop="statusDesc">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.homePageRecommend === 1" @change="changeRecommend($event, scope.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="频道屏蔽" min-width="90" align="center" prop="statusDesc">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.companyHallShow === 0" @change="changeHallShow($event, scope.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="排序" min-width="90" align="center" prop="sortNo">
        <template slot="header">
          排序
          <el-popover ref="popover" placement="top" width="180" trigger="hover">
            <div>
              双击单元格可修改排序值<br>
              数值小的排在前面<br>
            </div>
          </el-popover>
          <i v-popover:popover class="el-icon-info"></i>
        </template>
        <template slot-scope="scope">
          <span v-if="!scope.row.sortNoEdit">{{scope.row.sortNo}}</span>
          <el-input-number v-focus v-if="scope.row.sortNoEdit" v-model="scope.row.sortNo"
                           style="width: 100%" :min="0" :max="2147483647" @blur="sortNoBlur(scope.row)" :controls="false"></el-input-number>
        </template>
      </el-table-column>
      <!-- <el-table-column label="状态" min-width="100" align="center" prop="updateTime" /> -->
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="queryList"
    />
  </div>
</template>

<script>
import {hallListPage, changeRecommend, changeHallShow, changeTenantSortNo} from "@/api/saas/package";
import { amountFormat } from "@/utils/index";

export default {
  name: "BusinessList",
  data() {
    return {
      statusOptions: [],
      typeOptions: [{
        code: '1',
        name: '企业'
      },{
        code: '2',
        name: '组织'
      },{
        code: '3',
        name: '专家'
      }],
      total: 0,
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        tenantType: null,
        linkTel: null,
        tenantName: null,
        linkNickName: null,
        companyHallShow: null,
        homePageRecommend: null
      },
      statusList: [{
        value: 1,
        name: '已推荐'
      },{
        value: 0,
        name: '未推荐'
      }],
      showList: [{
        value: 1,
        name: '未屏蔽'
      },{
        value: 0,
        name: '已屏蔽'
      }],
      dataList: [],
      amountFormat
    };
  },
  created() {
    this.queryList();
  },
  components: {
  },
  watch: {
    customerId(val) {
      if (val) {
        this.queryList();
      } else {
        this.dataList = [];
      }
    },
    contactId(val) {
      if (val) {
        this.queryList();
      } else {
        this.dataList = [];
      }
    }
  },
  methods: {
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.queryList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.queryParams.userId = null;
      this.handleQuery();
    },
    handleAddText() {
      this.$refs.addTextDialogRef.open();
    },
    getList() {},
    queryList() {
      console.log("business queryList");
      this.loading = true;
      hallListPage(this.queryParams)
        .then(response => {
          let rows = response.rows || []
          rows.forEach(item => {
            item.originalSortNo = item.sortNo
            item.sortNoEdit = false
          })
          this.dataList = rows
          this.total = response.total
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeRecommend(e, row) {
      changeRecommend({
        tenantId: row.tenantId,
        homePageRecommend: e ? 1:0
      })
        .then(response => {
          this.msgSuccess(e ? '首页推荐成功' : '取消推荐成功')
          this.queryList()
        })
        .catch(error => {
          this.loading = false;
        });
    },
    changeHallShow(e, row) {
      changeHallShow({
        tenantId: row.tenantId,
        companyHallShow: row.companyHallShow === 0 ? 1 : 0
      }).then(response => {
        this.msgSuccess(e ? '屏蔽成功' : '取消屏蔽成功')
        this.queryList()
      })
    },
    dbClick (row, column, cell, event) {
      if (column.label === '排序') {
        row.sortNoEdit = true
      }
    },
    sortNoBlur (row) {
      row.sortNoEdit = false
      if (row.originalSortNo === row.sortNo) {
        return
      }
      const loading = this.$loading({lock: true, text: '修改中', spinner: 'el-icon-loading'});
      changeTenantSortNo({
        tenantId: row.tenantId,
        sortNo: row.sortNo
      }).then(response => {
        this.msgSuccess("修改成功")
        this.queryList();
      }).finally(()=>{
        loading.close()
      })
    }
  }
};
</script>
